import { useEffect, type ReactNode } from 'react'
import { Outlet, useMatches } from 'react-router'

type RouteMetadataProps = {
  appName: string
  fallbackTitle?: string
  children?: ReactNode
}

export function RouteMetadata({
  appName,
  fallbackTitle = 'Fant ikke siden',
  children
}: RouteMetadataProps) {
  const titles = useMatches()
    .map(({ handle }) => (handle as { title?: string } | undefined)?.title)
    .filter((title) => typeof title === 'string')
  const title = titles.at(-1) ?? fallbackTitle

  useEffect(() => {
    document.title = `${title} | ${appName}`
  }, [appName, title])

  return children ?? <Outlet />
}
